// extracted by mini-css-extract-plugin
module.exports = {"occurrenceSection":"styles_occurrenceSection__ojG8r","occurrenceSectionHeader":"styles_occurrenceSectionHeader__zKauU"};